<template>
  <article class="blog__saved-item d-flex flex-column">
    <div class="blog__saved-header d-flex justify-content-center align-items-center">
        <a :href="articleLink" class="blog__saved-avatar" :style="mainImage"></a>
    </div>
    <div class="blog__saved-body">
        <div class="blog__saved-meta d-flex">
            <a :href="user.href" class="blog__saved-meta-item d-flex align-items-center">
                <img :src="user.avatar" alt="">
                <span v-text="user.name"></span>
            </a>
            <a :href="target.href" class="blog__saved-meta-item d-flex align-items-center">
                <img :src="target.avatar" alt="">
                <span v-text="target.name"></span>
            </a>
        </div>
        <h3 class="blog__saved-title">
            <a :href="articleLink" v-text="article.title"></a>
        </h3>
        <div class="blog__saved-descr" v-text="striptagsContent"></div>
    </div>
    <div class="blog__saved-footer d-flex justify-content-center">
        <a :href="articleLink" class="btn">{{$store.getters.t('blog_saved_read_story')}}</a>
    </div>
  </article>
</template>

<script>
export default {
    name: "SavedArticle",
    props: {
        article: {
            type: Object,
            required: true
        }
    },

    computed: {
        
        articleLink(){
            return `/blog/${this.article.category.slug}/${this.article.slug}`
        },

        mainImage(){
            let { path } = this.article.main_image
            return {
                backgroundImage: `url(${this.handleImage( path, 'preview' )})`
            }
        },

        target(){
            let { avatar, name, id } = this.article.happy_postable
            let type = this.article.happy_type.includes('Pet') ? 'pets' : 'projects'
            let href = `/${type}/${id}`

            return {
                name,
                href,
                avatar: this.handleImage( avatar.path )
            }

        },

        user(){
            let { avatar, name, id } = this.article.happy_postable.user
            return {
                name,
                href: `/user/${id}/profile`,
                avatar: this.handleImage( avatar.path )
            }
        },

        striptagsContent() {
            return (this.article.content).replace(/<\/?[^>]+(>|$)/g, "")
        },

    },

    methods: {

        handleImage( path, replacer = 'avatar' ){
            return (`/storage/${path}`).replace( 'original', replacer )
        }

    }

}
</script>

<style>

</style>
